import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Checkbox, IconButton, LinearProgress } from '@mui/material';
import { Delete, Edit, AccessTime } from '@mui/icons-material';

const CalendarTaskList = ({ tasks, onDeleteTask, onEditTask, onCompleteTask, formatDate }) => {
  return (
    <Box sx={{ 
      background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      borderRadius: 2,
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      color: 'white',
      padding: 3,
    }}>
      <Typography variant="h6" gutterBottom>Tâches</Typography>
      {tasks.map((task) => (
        <motion.div
          key={task.id}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
        >
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mb: 2, 
            p: 2, 
            bgcolor: 'rgba(255,255,255,0.1)', 
            borderRadius: 1 
          }}>
            <Checkbox 
              checked={task.completed} 
              onChange={() => onCompleteTask(task.id)} 
            />
            <Box sx={{ flexGrow: 1, ml: 2 }}>
              <Typography variant="subtitle1" sx={{ textDecoration: task.completed ? 'line-through' : 'none' }}>
                {task.title}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <AccessTime fontSize="small" />
                <Typography variant="caption" sx={{ ml: 1 }}>
                  {formatDate(task.dueDate)}
                </Typography>
              </Box>
              <LinearProgress 
                variant="determinate" 
                value={task.progress} 
                sx={{ mt: 1, height: 4, borderRadius: 2 }} 
              />
            </Box>
            <IconButton onClick={() => onEditTask(task.id)}>
              <Edit />
            </IconButton>
            <IconButton onClick={() => onDeleteTask(task.id)}>
              <Delete />
            </IconButton>
          </Box>
        </motion.div>
      ))}
    </Box>
  );
};

export default CalendarTaskList;